import * as React from 'react';
import classNames from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import isString from 'lodash/isString';
import './cn-step-item.scss';
/**
 * @category 组件
 * @description 步骤组件的子组件
 */
export const CnStepItem = (props) => {
    const { order, shape, isFirst, isLast, disabled, isPreDisabled, direction, addon, extra, title, content, contentRender, status, className, icon, onClick, ...others } = props;
    const clsPrefix = 'cn-ui-m-step-item';
    const isCircle = shape === 'circle';
    const classes = {
        item: classNames(clsPrefix, className, `${clsPrefix}--${status}`, `${clsPrefix}--shape-${shape}`, {
            [`${clsPrefix}--last`]: isLast,
            [`${clsPrefix}--first`]: isFirst,
            [`${clsPrefix}--disabled`]: disabled,
            [`${clsPrefix}--pre-disabled`]: isPreDisabled,
        }),
        dot: classNames(`${clsPrefix}-dot`),
        indicator: `${clsPrefix}-indicator`,
        hornLeft: classNames(`${clsPrefix}-horn`, `${clsPrefix}-horn--left`, {
            [`${clsPrefix}-horn--hide`]: isFirst,
        }),
        hornRight: classNames(`${clsPrefix}-horn`, `${clsPrefix}-horn--right`, {
            [`${clsPrefix}-horn--hide`]: isLast,
        }),
        node: classNames(`${clsPrefix}-node`),
        addon: classNames(`${clsPrefix}-addon`, {
            [`${clsPrefix}-addon--first`]: isFirst,
        }),
    };
    const renderCircleContent = () => {
        if (isCircle) {
            if (isString(icon) && icon !== '') {
                return React.createElement(CnIcon, { type: icon, size: "xs" });
            }
            else if (status === 'finish') {
                return React.createElement(CnIcon, { type: "complete", size: "xs" });
            }
            else {
                return (order || 0) + 1;
            }
        }
        else {
            return null;
        }
    };
    return (React.createElement("div", { ...others, className: classes.item, onClick: onClick },
        addon && direction === 'ver' ? (React.createElement("div", { className: classes.addon }, addon)) : null,
        React.createElement("div", { className: classes.indicator },
            React.createElement("div", { className: classes.hornLeft }),
            React.createElement("div", { className: classes.node },
                " ",
                renderCircleContent()),
            React.createElement("div", { className: classes.hornRight })),
        React.createElement("div", { className: `${clsPrefix}-body` },
            direction === 'hoz' && (React.createElement("div", { className: `${clsPrefix}-title` }, title)),
            direction === 'ver' && (React.createElement("div", { className: `${clsPrefix}-body-header` },
                React.createElement("div", { className: `${clsPrefix}-title` }, title),
                React.createElement("div", { className: `${clsPrefix}-extra` }, extra))),
            contentRender && contentRender(props, order || 0),
            (!contentRender && content) && React.createElement("div", { className: `${clsPrefix}-content` }, content))));
};
CnStepItem.displayName = 'CnStepItem';
CnStepItem.defaultProps = {
    isFirst: false,
    isLast: false,
    disabled: false,
    isPreDisabled: false,
};
